import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from "../libs/contextLib";
import './CustomFooter.scss'

export default function CustomFooter(){
	const { language } = useAppContext();
	const history = useHistory();

	return (
		<div className="CustomFooter">
			{ language === "es" ? 
  					<p>
						Licencia MIT Copyright (c) 2022 Cornell University
					</p>: 
  					<p>
						MIT License
						Copyright (c) 2022 Cornell University
					</p>
			}
		</div>
	);
}
